module.exports = __webpack_public_path__ + "media/images/faces/male/4-a878d3fa5b4543fe8064bf395402fa6c.jpg";